import BaseMapController from "../common/map/base_map_controller";
import {FeatureLike} from "ol/Feature";
import {Feature} from "ol";
import {Style} from "ol/style";
import {fromLonLat} from "ol/proj";
import {Point} from "ol/geom";
import Overlay from "ol/Overlay";
import urgentMarkerUrl from "../../../assets/icons/urgent-map-marker.svg";
import markerUrl from "../../../assets/icons/map-marker.svg";
import {formatMoney} from "../../../js/formatters";
import {urgentIconStyle} from "../common/map/urgentIconStyle";
import {defaultIconStyle} from "../common/map/defaultIconStyle";

export default class extends BaseMapController<{ location: { lat: number, lon: number }, id: number, urgent: boolean }> {
  private popup: HTMLElement | null = null;
  private popupOverlay: Overlay | null = null;

  initMap() {
    super.initMap();

    this.popup = document.getElementById('popup');
    if (this.popup) {
      this.popupOverlay = new Overlay({
        element: this.popup,
        // positioning: 'bottom-center',
        offset: [0, 20], // Adjust this to position below your marker
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });

      this.map?.addOverlay(this.popupOverlay);
    }
  }

  protected getFeatureStyle(feature: FeatureLike): Style {
    return feature.get('urgent') ? urgentIconStyle : defaultIconStyle;
  }

  protected featureClickHandler(features: FeatureLike[]): void {
    const feature = features[0];
    if (!feature && this.popup) {
      this.popup.innerHTML = '';
      return;
    }

    fetch(`/public/announcements/${feature.get('id')}.json`)
    .then(response => response.json())
    .then(announcement => {
      if (!this.popup) return;

      this.popup.innerHTML = `
      <img src="${announcement.urgent ? urgentMarkerUrl : markerUrl}" style="width: 32px; height: 32px; position: absolute; left: -17px; bottom: -9px" alt="marker" />
      <a href="/public/announcements/${announcement.id}" data-turbo="false">
        ${announcement.advertising_thumb_url ?
          `<div class="card-header p-0 mx-0 mt-0 position-relative">
            <img class="img-fluid border-radius-lg header-image" src="${announcement.advertising_thumb_url}" alt="announement advertising image">
          </div>`
          : ''}
        <div class="card-body p-3 d-flex flex-column">
          <div class="title mb-1">
            ${announcement.title}
          </div>
          <div class="ol-popup-content">
            ${announcement.short_description}
          </div>
          ${announcement.min_cost ?
            `<div class="price">
                ${formatMoney(announcement.min_cost)}
              </div>`
            : ''
          }
        </div>
      </a>`

      const geometry = feature.getGeometry();
      if (geometry) {
        this.popupOverlay?.setPosition((geometry as any).getCoordinates());
      }

      const closer = this.popup?.querySelector('.popup-closer') as HTMLElement;
      if (closer) {
        closer.onclick = () => {
          this.popupOverlay?.setPosition(undefined);
          return false;
        };
      }
    });
  }

  protected async loadPoints(params: URLSearchParams): Promise<{ location: { lat: number, lon: number }, id: number, urgent: boolean }[]> {
    let requestUrl = `points?${params.toString()}`;

    const response = await fetch(requestUrl);
    return response.json();
  }
  protected pointToFeature(point: { location: { lat: number, lon: number }, id: number, urgent: boolean }): Feature {
    const feature = new Feature({
      geometry: new Point(fromLonLat([point.location.lon, point.location.lat]))
    });

    feature.set("id", point.id);
    feature.set("urgent", point.urgent);

    return feature;
  }
}
